module.exports = __webpack_public_path__ + "img/BeccaF2.e8211d3f.jpg";